export const ADMIN = 'admin';
export const SELLER = 'seller';
export const CATALOG = 'catalog';
export const COMERCIAL = 'comercial';
export const LOGISTICS = 'logistics';
export const CUSTOMER_SERVICE = 'customerService';
export const STORE = 'store';
export const SYSADMIN = 'sysadmin';
export const SECURITY = 'security';
